import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeerVerticalNameWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-peer-vertical-name-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="stat-card">
      <span class="stat-card__label">Compared to</span>
      <ng-container *ngIf="data as widget; else noData">
        <span class="stat-card__value">{{ widget.name }}</span>
      </ng-container>
      <ng-template #noData>
        <p class="stat-card__empty">No data available.</p>
      </ng-template>
    </div>
  `,
  styleUrl: '../stat-card.scss',
})
export class PeerVerticalNameWidgetComponent {
  @Input() data: PeerVerticalNameWidget | null = null;
}
